export default __webpack_public_path__ + "static/media/PinheiroCampos.c9adf62b.jpg";